import { SegmentEventFieldsTypes } from '../../../types/zodSchemaTypes';

export class SegmentEventField {
  type: string;
  field: string;
  key: string | undefined;
  dependentField: string | undefined;
  extraInfoDependentField: string | undefined;
  dependentFormField: string | undefined;
  matchValue: string | undefined;
  dateFormat: string | undefined;
  timeFormat: string | undefined;
  dependentSegmentField: string | undefined;
  preferredSlotFormFieldKey: string | undefined;
  preferredDateFormFieldKey: string | undefined;
  defaultValue: string | undefined;

  constructor(segmentEventField: SegmentEventFieldsTypes) {
    this.type = segmentEventField.type;
    this.field = segmentEventField.field;
    this.key = segmentEventField.key;
    this.dependentField = segmentEventField.dependent_field;
    this.extraInfoDependentField = segmentEventField.extra_info_dependent_field;
    this.dependentFormField = segmentEventField.dependent_form_field;
    this.matchValue = segmentEventField.match_value;
    this.dateFormat = segmentEventField.date_format;
    this.timeFormat = segmentEventField.time_format;
    this.dependentSegmentField = segmentEventField.dependent_segment_field;
    this.preferredSlotFormFieldKey =
      segmentEventField.preferredSlotFormFieldKey;
    this.preferredDateFormFieldKey =
      segmentEventField.preferredDateFormFieldKey;
    this.defaultValue = segmentEventField.default_value;
  }
}
